import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pages/accueil/stars.png")